import z from "zod";
import { ProjectDraftDataSchema, ProjectDraftSchema, ProjectDraftSummarySchema } from "./entity";

export const DraftProjectSchemas = {
  list: {
    response: ProjectDraftSummarySchema.array(),
  },
  find: {
    request: z.object({ id: z.uuidv7() }),
    response: ProjectDraftSchema,
  },
  create: {
    request: z.object({ data: ProjectDraftDataSchema }),
    response: ProjectDraftSchema,
  },
  update: {
    request: z.object({ id: z.uuidv7(), data: ProjectDraftDataSchema }),
    response: ProjectDraftSchema,
  },
  delete: z.object({ id: z.uuidv7() }),
};

export type ProjectDraftData = z.infer<typeof ProjectDraftDataSchema>;
export type ProjectDraft = z.infer<typeof ProjectDraftSchema>;
export type ProjectDraftSummary = z.infer<typeof ProjectDraftSummarySchema>;
